/*
 *
 *  actions
 *
 */

import {
  LOAD_DYNAMIC_IMAGES_LIST,
  LOAD_DYNAMIC_IMAGES_LIST_SUCCESS,
  LOAD_DYNAMIC_IMAGES_LIST_ERROR,
  LOAD_BEST_SELLING_DETAILS_IMAGES,
  LOAD_BEST_SELLING_DETAILS_IMAGES_SUCCESS,
  LOAD_BEST_SELLING_DETAILS_IMAGES_ERROR,
  CREATE_PAYMENT_IN_DETAILS,
  CREATE_PAYMENT_IN_DETAILS_SUCCESS,
  CREATE_PAYMENT_IN_DETAILS_ERROR,
  UPDATE_PAYMENT_IN_DETAILS,
  UPDATE_PAYMENT_IN_DETAILS_SUCCESS,
  UPDATE_PAYMENT_IN_DETAILS_ERROR,
  DELETE_PAYMENT_IN_DETAILS,
  DELETE_PAYMENT_IN_DETAILS_SUCCESS,
  DELETE_PAYMENT_IN_DETAILS_ERROR,
  LOAD_DYNAMIC_IMAGES_LIST_RECORDS_META_DATA,
  LOAD_DYNAMIC_IMAGES_LIST_RECORDS_META_DATA_SUCCESS,
  LOAD_DYNAMIC_IMAGES_LIST_RECORDS_META_DATA_ERROR,
  LOAD_DEALS_LIST,
  LOAD_DEALS_LIST_SUCCESS,
  LOAD_DEALS_LIST_ERROR,
  LOAD_HOLIDAYS_LIST,
  LOAD_HOLIDAYS_LIST_SUCCESS,
  LOAD_HOLIDAYS_LIST_ERROR,
  LOAD_TESTIMONIAL_LIST,
  LOAD_TESTIMONIAL_LIST_SUCCESS,
  LOAD_TESTIMONIAL_LIST_ERROR,
  LOAD_DESTINATION_LIST,
  LOAD_DESTINATION_LIST_SUCCESS,
  LOAD_DESTINATION_LIST_ERROR,
  LOAD_PACKAGES_CATEGORY_LIST,
  LOAD_PACKAGES_CATEGORY_LIST_SUCCESS,
  LOAD_PACKAGES_CATEGORY_LIST_ERROR,
} from "./constants";

// load payment in
export function loadDynamicImagesList() {
  return {
    type: LOAD_DYNAMIC_IMAGES_LIST,
  };
}

export function loadDynamicImagesListSuccess(dynamic_images_list, success) {
  return {
    type: LOAD_DYNAMIC_IMAGES_LIST_SUCCESS,
    dynamic_images_list,
    success,
  };
}

export function loadDynamicImagesListError(error) {
  return {
    type: LOAD_DYNAMIC_IMAGES_LIST_ERROR,
    error,
  };
}
// load parties
export function loadBestSellingDetailsImages(imageList) {
  return {
    type: LOAD_BEST_SELLING_DETAILS_IMAGES,
    imageList,
  };
}

export function loadBestSellingDetailsImagesSuccess(
  best_selling_details,
  success
) {
  return {
    type: LOAD_BEST_SELLING_DETAILS_IMAGES_SUCCESS,
    best_selling_details,
    success,
  };
}

export function loadBestSellingDetailsImagesError(error) {
  return {
    type: LOAD_BEST_SELLING_DETAILS_IMAGES_ERROR,
    error,
  };
}

//payment in report

// load payment in
export function loadDestinationList(destinations) {
  return {
    type: LOAD_DESTINATION_LIST,
    destinations,
  };
}

export function loadDestinationListSuccess(destination_list, success) {
  return {
    type: LOAD_DESTINATION_LIST_SUCCESS,
    destination_list,
    success,
  };
}

export function loadDestinationListError(error) {
  return {
    type: LOAD_DESTINATION_LIST_ERROR,
    error,
  };
}

export function loadPackageCategoryList(destinations) {
  return {
    type: LOAD_PACKAGES_CATEGORY_LIST,
    destinations,
  };
}

export function loadPackageCategoryListSuccess(package_category_list, success) {
  return {
    type: LOAD_PACKAGES_CATEGORY_LIST_SUCCESS,
    package_category_list,
    success,
  };
}

export function loadPackageCategoryListError(error) {
  return {
    type: LOAD_PACKAGES_CATEGORY_LIST_ERROR,
    error,
  };
}

// load dealsList
export function loadDealsList(dealsList) {
  return {
    type: LOAD_DEALS_LIST,
    dealsList,
  };
}

export function loadDealsListSuccess(deals_list, success) {
  return {
    type: LOAD_DEALS_LIST_SUCCESS,
    deals_list,
    success,
  };
}

export function loadDealsListError(error) {
  return {
    type: LOAD_DEALS_LIST_ERROR,
    error,
  };
}

// load holidays
export function loadHolidaysList(holidayList) {
  return {
    type: LOAD_HOLIDAYS_LIST,
    holidayList,
  };
}

export function loadHolidaysListSuccess(holidays_list, success) {
  return {
    type: LOAD_HOLIDAYS_LIST_SUCCESS,
    holidays_list,
    success,
  };
}

export function loadHolidaysListError(error) {
  return {
    type: LOAD_HOLIDAYS_LIST_ERROR,
    error,
  };
}

// load testimonials
export function loadTestimonialList(testimonialList) {
  return {
    type: LOAD_TESTIMONIAL_LIST,
    testimonialList,
  };
}

export function loadTestimonialListSuccess(testimonial_list, success) {
  return {
    type: LOAD_TESTIMONIAL_LIST_SUCCESS,
    testimonial_list,
    success,
  };
}

export function loadTestimonialListError(error) {
  return {
    type: LOAD_TESTIMONIAL_LIST_ERROR,
    error,
  };
}

// load parties
export function createPaymentInList(paymentDetails) {
  return {
    type: CREATE_PAYMENT_IN_DETAILS,
    paymentDetails,
  };
}

export function createPaymentInListSuccess(paymentDetails, success) {
  return {
    type: CREATE_PAYMENT_IN_DETAILS_SUCCESS,
    paymentDetails,
    success,
  };
}

export function createPaymentInListError(error) {
  return {
    type: CREATE_PAYMENT_IN_DETAILS_ERROR,
    error,
  };
}
// load parties
export function updatePaymentInList(paymentDetails) {
  return {
    type: UPDATE_PAYMENT_IN_DETAILS,
    paymentDetails,
  };
}

export function updatePaymentInListSuccess(paymentDetails, success) {
  return {
    type: UPDATE_PAYMENT_IN_DETAILS_SUCCESS,
    paymentDetails,
    success,
  };
}

export function updatePaymentInListError(error) {
  return {
    type: UPDATE_PAYMENT_IN_DETAILS_ERROR,
    error,
  };
}
// load parties
export function deletePaymentInList(paymentDetails) {
  return {
    type: DELETE_PAYMENT_IN_DETAILS,
    paymentDetails,
  };
}

export function deletePaymentInListSuccess(paymentDetails, success) {
  return {
    type: DELETE_PAYMENT_IN_DETAILS_SUCCESS,
    paymentDetails,
    success,
  };
}

export function deletePaymentInListError(error) {
  return {
    type: DELETE_PAYMENT_IN_DETAILS_ERROR,
    error,
  };
}

export function loadDynamicImagesListRecordsMetaData() {
  return {
    type: LOAD_DYNAMIC_IMAGES_LIST_RECORDS_META_DATA,
  };
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadDynamicImagesListRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_DYNAMIC_IMAGES_LIST_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  };
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadDynamicImagesListRecordsMetaDataError(error) {
  return {
    type: LOAD_DYNAMIC_IMAGES_LIST_RECORDS_META_DATA_ERROR,
    error,
  };
}

const actions = {
  loadDynamicImagesList,
  loadDynamicImagesListSuccess,
  loadDynamicImagesListError,
  loadDestinationList,
  loadDestinationListSuccess,
  loadDestinationListError,
  loadPackageCategoryList,
  loadPackageCategoryListSuccess,
  loadPackageCategoryListError,

  loadDealsList,
  loadDealsListSuccess,
  loadDealsListError,

  loadHolidaysList,
  loadHolidaysListSuccess,
  loadHolidaysListError,

  loadTestimonialList,
  loadTestimonialListSuccess,
  loadTestimonialListError,

  createPaymentInList,
  createPaymentInListSuccess,
  createPaymentInListError,
  updatePaymentInList,
  updatePaymentInListSuccess,
  updatePaymentInListError,

  deletePaymentInList,
  deletePaymentInListSuccess,
  deletePaymentInListError,

  loadDynamicImagesListRecordsMetaData,
  loadDynamicImagesListRecordsMetaDataSuccess,
  loadDynamicImagesListRecordsMetaDataError,
  loadBestSellingDetailsImages,
  loadBestSellingDetailsImagesSuccess,
  loadBestSellingDetailsImagesError,
};

export default actions;
